import script from "./SelectableField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectableField.vue?vue&type=script&lang=ts&setup=true"

import "./SelectableField.vue?vue&type=style&index=0&id=10adc5d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10adc5d2"]])

export default __exports__